import React from 'react';
import { useCart } from './CartContext';
import './CartIcon.css';

function CartIcon({ onToggle }) {
  const { getTotalCount } = useCart();
  const count = getTotalCount();
  const isEmpty = count === 0;

  return (
    <div
      className={`cart-icon ${isEmpty ? 'empty' : 'not-empty'}`}
      onClick={onToggle}
      role="button"
      aria-label="购物车"
    >
      <span className="cart-icon-emoji">🛒</span>
      {!isEmpty && (
        <span className="cart-badge">{count > 99 ? '99+' : count}</span>
      )}
    </div>
  );
}

export default CartIcon;
